import React, {useEffect} from 'react'
import './Pup.css'
import Androidscreenshoot from '../images/Pup/Androidscreenshoot.png'
import Artboard1 from '../images/Pup/Artboard1.png'
import Artboard2 from '../images/Pup/Artboard2.png'
import Artboard3 from '../images/Pup/Artboard3.png'
import Artboard4 from '../images/Pup/Artboard4.png'
import Artboard5 from '../images/Pup/Artboard5.png'
import Artboard6 from '../images/Pup/Artboard6.png'
import Artboard7 from '../images/Pup/Artboard7.png'
import Artboard8 from '../images/Pup/Artboard8.png'

import Artboard10 from '../images/Pup/Artboard10.png'
import Footer from '../Component/footer'

function Pup() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       

        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
 
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
       
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}

export default Pup
